import styled from 'styled-components'

export const DialogInnerContainer = styled.div`
  flex-direction: column;
  display: flex;
  gap: 16px;
  margin-top: 16px;
  font-size: 14px;
`

export const OptionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const OptionText = styled.div`
  flex: 60%;
  flex-shrink: 0;
`

export const ShowDialogButton = styled.button`
  color: inherit;
  cursor: pointer;
  border: none;
  background: transparent;
  padding: 0;
  font-size: 13px;
  text-align: left;
  :hover {
    text-decoration: underline;
  }
`
